// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__8QizD","footer":"ModalCreateQualiphyProcedure_footer__1VOes","additionData":"ModalCreateQualiphyProcedure_additionData__1lbMu"};